<template>
  <div class="login">
   <p style="margin-bottom:4vh">
    <img  src="../assets/image/gx.png" alt="">
   </p>
      <div class="login-frm infoLogin">
        <p class="frm-title">用户登录</p>
        <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="0px" >
          <!-- 用户名 -->
          <el-form-item prop="username">
            <el-input auto-complete="off" style="color:#f00" placeholder="请输入您的账号" v-model="loginForm.username">
              <i slot="prefix" class="el-input__icon el-icon-user" style="line-height: initial;"></i>
            </el-input>
          </el-form-item>
          <!-- 密码 -->
          <el-form-item prop="password">
            <el-input auto-complete="off" type="password" placeholder="请输入您的密码" v-model="loginForm.password">
               <i slot="prefix" class="el-input__icon el-icon-lock" style="line-height: initial;"></i>
            </el-input>
          </el-form-item>
          <!-- 按钮区域 -->
          <el-form-item class="btn-con">
            <el-button type="primary" @click="login('loginFormRef')">登录</el-button>
          </el-form-item>
        </el-form>
        <!-- <el-collapse-transition>
          <div v-show="codeShow" class="qrCode-box">
            <img :src="qrCode" />
          </div>
        </el-collapse-transition> -->
      </div>
  </div>
</template>
<script>
import { async } from 'q';
import myHttp from "../untils/port.js";
import util from '../untils/util';
export default {
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginFormRules: {
        username: [
          { require: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [
          { require: true, message: "请输入登录密码", trigger: "blur" }
        ]
      },
      // qrCode:require('../assets/images/wisdom.png'),
      codeShow:false
    }
  },
  methods: {
       login(formName) {
            let that = this;
            if(this.loginForm.username==''){
                this.$message.error('请输入用户名');
                return;
            }
            if(this.loginForm.password==''){
                this.$message.error('请输入登录密码');
                return;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    myHttp.login({
                        username:that.loginForm.username,
                        password:that.loginForm.password
                    }).then(function(resp){
                        if(resp.data.code=="200"){
                        util.session.set('token',resp.data.data.token.accessToken);
                        util.session.set('user',resp.data.data.user);
                        util.session.set('type','7');
                        var roleList = resp.data.data.relations||[]
                        var list = []
                        for(var i=0;i<roleList.length;i++){
                            if(roleList[i].userType=='3'){
                                list.unshift(roleList[i])
                            }else if(roleList[i].userType!='2'&&roleList[i].userType!='1'&&roleList[i].userType!='6'){
                                list.push(roleList[i])
                            }
                        }
                        util.session.set('role',list);
                        that.$store.commit("getToken");
                        that.$store.commit("setUser");
                        that.$store.commit("getRole");
                        //var roleList = resp.data.data.relations;
                        // if(roleList.length>0){
                        //     if(roleList[0].userType=='1'){
                        //     that.$router.push({ name: 'userMan' })
                        //     }else if(roleList[0].userType=='3'){
                        //     that.$router.push({ name: 'stateData' })
                        //     }else if(roleList[0].userType=='4'){
                        //     that.$router.push({ name: 'homeAll' })
                        //     }else if(roleList[0].userType=='2'){
                        //     that.$router.push({ path: '/supProjects' })
                        //     }else{
                        //     that.$router.push({ path: '/' })
                        //     }
                        // }else{
                            // if(that.filterPort(list,5)){
                            //     that.$router.push({ path: '/comHome' })
                            // }else if(that.filterPort(list,4)){
                            //     that.$router.push({ path: '/homeAll' })
                            // }else if(that.filterPort(list,3)){
                                that.$router.push({ path: '/buildHome' })
                            // }
                        //}
                        }else{
                            that.$message.error(resp.data.msg);
                        }
                    },function(){});
                }
            });
        },
        //判断有没有端
        filterPort(list,port){
            var result = false
            for(var i=0;i<list.length;i++){
                if(list[i].userType==port){
                    result = true
                }
            }
            return result
        },
  }
}
</script>
<style scoped>
  .login{
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    background: url('../assets/image/login_gx.png');
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    justify-items: center;
    align-items: center;
    align-content: center;
  }

 /*----------- 主体 -----------*/

  .login-frm {
    width: 29vw;
    height: 50vh;
    position: relative;
    background: #fff;
    border-radius: 2vh;
    /* box-shadow:0px 0px 54px rgba(4,106,85,0.39); */
    padding: 4vh 3.5vw;
  }
  .frm-title{
    font-size: 1.6vw;
    color:#007FE1;
    text-align: left;
  }



  .login-img {
    width: 56%;
    height: 100%;
    float: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .login-img img {
    width: 90%;
  }
  .el-form {
    position: relative;
    height: 70%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .el-form .el-frm-tit {
    font-size: 24px;
    text-align: center;
  }
  .el-form .el-form-item {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .el-form .el-form-item:nth-child(1) {
    margin-top: 2vh;
    /* border-bottom: 1px solid #8b8b8b; */
    width: 100%;
    position: relative;
    height: 6vh;
  }
  .el-form .el-form-item:nth-child(2) {
    /* border-bottom: 1px solid #8b8b8b; */
    width: 100%;
    position: relative;
    margin-top: 2vh;
    height: 6vh;
  }
  .el-form .el-form-item:nth-child(3) {
    border-bottom: none;
  }
  
  .el-form-item .el-input {
    width: 100%;
    /* margin-left: 10px; */
    font-size: 2vh;
    height: 100%;
  }
  .el-form-item >>> .el-input__inner {
    border-radius: 0;
    /* border: none; */
    height: 100%;
    
  } 

  .btn-con{
    position: absolute;
    bottom: -10vh;
    width: 100%;
    height: 6vh;
    display: flex;
    justify-content: center;
    justify-items: center;
    align-content: center;
    align-items: center;
  }
  .el-button {
    background: #358ADA;
    width: 100%;
    height: 100%;
    position: relative;
    border: none;
    font-size: 1.6vw;
    border-radius: 4vh;
  }
  
</style>
<style>
  .infoLogin .el-form-item__content{
    width: 100%;
    position: relative;
    height: 100%;
  }
  .infoLogin .el-input{
    max-width: initial;
  }
  @import '../assets/css/common.css';
</style>